module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collaboration"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "collaboration-list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.collaborationList), function(item, index) {
    return [_c('div', {
      key: index + 'coll',
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "collaboration-list-item wow flipInY",
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "collaboration-list-item-img"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "school"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "collaboration-list-item-logo"
    }, [_c('img', {
      attrs: {
        "src": item.logo,
        "alt": "school"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "collaboration-list-item-content"
    }, [_c('div', {
      staticClass: "collaboration-list-item-content-box"
    }, [_c('div', {
      staticClass: "collaboration-list-item-content-tit"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "collaboration-list-item-content-dec"
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._v("\n                      " + _vm._s(item.desc) + "\n                    ")])])])])])])]
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "collaboration-content"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "col-lg-10 col-md-10",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-topBox"
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-tit"
  }, [_vm._v("International activities")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item wow bounceIn",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top",
    staticStyle: {
      "height": "50%"
    },
    style: ({
      '--bgColor': '#DF7E49'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-top-nr-text"
  }, [_vm._v("China Europe Civilization Forum")]), _vm._v(" "), _c('div', {
    staticClass: "tem-top-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('1', 'collaborationDetails')
      }
    }
  }, [_vm._v("More …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collaboration-content-topBox-item-top",
    staticStyle: {
      "height": "50%"
    },
    style: ({
      '--bgColor': '#810900'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-top-nr-text"
  }, [_vm._v("China-France Higher Education Forum")]), _vm._v(" "), _c('div', {
    staticClass: "tem-top-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('2', 'collaborationDetails')
      }
    }
  }, [_vm._v("More …")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item wow bounceIn",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top",
    style: ({
      '--bgColor': '#E29B74'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-top-nr-text"
  }, [_vm._v("International Academic Conference on Global Evolution of Population Aging from an Interdisciplinary Perspective")]), _vm._v(" "), _c('div', {
    staticClass: "tem-top-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('3', 'collaborationDetails')
      }
    }
  }, [_vm._v("More …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collaboration-content-topBox-item-bot"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item wow bounceIn",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top",
    staticStyle: {
      "height": "50%"
    },
    style: ({
      '--bgColor': '#611D1D'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-top-nr-text"
  }, [_vm._v("Policy Forum in Asia")]), _vm._v(" "), _c('div', {
    staticClass: "tem-top-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('4', 'collaborationDetails')
      }
    }
  }, [_vm._v("More …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collaboration-content-topBox-item-top",
    staticStyle: {
      "height": "50%"
    },
    style: ({
      '--bgColor': '#DB7547'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-top-nr-text"
  }, [_vm._v("World Congress of Sinology")]), _vm._v(" "), _c('div', {
    staticClass: "tem-top-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('5', 'collaborationDetails')
      }
    }
  }, [_vm._v("More …")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collaboration-content-bottomBox"
  }, [_c('div', {
    staticClass: "collaboration-content-bottomBox-box"
  }, [_c('div', {
    staticClass: "collaboration-content-bottomBox-tit"
  }, [_vm._v("International Exchange and Cooperation Programs")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-botBox-item-bot2 wow bounceIn",
    style: ({
      '--bgColor': '#DF7E49'
    })
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "collaboration-content-topBox-item-bot"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-botBox-item-bot2 wow bounceIn",
    style: ({
      '--bgColor': '#810900'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-bot-nr-text"
  }, [_vm._v("\n                    China-Europe European Law Program\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tem-bot-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('6', 'internationalDetails')
      }
    }
  }, [_vm._v("More …")])])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 collaboration-content-topBox-item",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-botBox-item-bot2 wow bounceIn",
    style: ({
      '--bgColor': '#D75C26'
    })
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-bot-nr-text"
  }, [_vm._v("\n                    International Exchange Program\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tem-bot-nr-btn"
  }, [_c('a', {
    staticClass: "genric-btn success-border circle",
    on: {
      "click": function($event) {
        return _vm.router('7', 'internationalDetails')
      }
    }
  }, [_vm._v("More …")])])])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-empty"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "collaboration-tit"
  }, [_c('div', {
    staticClass: "collaboration-tit-content"
  }, [_vm._v("\n      International partner universities\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collaboration-content-topBox-item-top-nr"
  }, [_c('div', {
    staticClass: "tem-bot-nr-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/collaboration/png9.png",
      "alt": "collaboration"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collaboration-content-topBox-item-bot"
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-bot-lf",
    staticStyle: {
      "background-color": "#E25A6A"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collaboration-content-topBox-item-bot"
  }, [_c('div', {
    staticClass: "collaboration-content-topBox-item-bot-lf",
    staticStyle: {
      "background-color": "#B02541"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "collaboration-content-rt"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ece3625"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Collaboration.vue
// module id = 71
// module chunks = 0